import request from '@/utils/httpRequest'
import { data } from 'jquery'


export function projectList(data) {
    return request({
        url: '/app/project/list',
        method: 'get',
        params: data
    })
}


export function syslogin(data) {
    return request({
        url: '/app/sys/loginByOa',
        method: 'post',
        data
    })
}

